import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { PersonalDataConfigService } from "./personal-data.config";
import { SarRequestDatasetsResponse, SarRequestResponse, SarRequestType } from "./personal-data.model";
/**
 * @deprecated - [fabric-deprecated] - Use PersonalDataService from app-account mfe instead
 */
@Injectable({
	providedIn: "root",
})
export class PersonalDataService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: PersonalDataConfigService
	) {}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestSarData) instead
	 */
	getRequests(): Observable<SarRequestResponse[]> {
		return this.httpClient.get<SarRequestResponse[]>({
			url: this.config.getEndpoint(),
			searchParams: {
				requestType: SarRequestType.Online,
			},
		});
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	requestDataSets(dataSets: string[]): Observable<SarRequestDatasetsResponse> {
		return this.httpClient.post<SarRequestDatasetsResponse>({
			url: this.config.getEndpoint(),
			data: {
				dataSets,
			},
		});
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.PersonalDataRequestDatasets) instead
	 */
	sendDownloadRequest(id: number): Observable<number> {
		return this.httpClient.patch<number>({
			url: `${this.config.getEndpoint()}/${id}/downloaded`,
		});
	}
}
